import { restrictions } from 'state/features-list/constants';
import type { Operator, List } from 'state/features-list/types';

export const wellBeingHub = 'wellBeingHub';
export const wellBeingRecommendations = 'wellBeingRecommendations';

export const MAXIMUM_TIER = 4;

type HubRestrictions = {
  user: List;
  operator: Operator;
};

export const HUB_RESTRICTIONS: HubRestrictions = {
  user: [
    restrictions['eap_challenges'],
    restrictions['wellbeing_rewards'],
    restrictions['wellbeing_tiering'],
  ],
  operator: 'OR',
};

export const RECOMMENDATION_RESTRICTIONS = {
  user: [restrictions['eap_self_assessment'], restrictions['eap_assistance']],
  operator: 'AND',
} as const;
